import { useRepositories } from '../../../contexts';
import { InvalidationTag, useAppQuery } from '../utils';
import { useLanguage } from '../../../locale';
export var useGetCountriesApi = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    var _a = useLanguage(), locale = _a[2];
    var countriesRepo = useRepositories().countriesRepo;
    return useAppQuery([InvalidationTag.Countries, locale], countriesRepo.getCountries, {
        enabled: enabled,
    });
};
